import {FormElementType} from "./formElementType";

export enum IndexType {
  Keyword = 'keyword',
  Double = 'double',
  Date = 'date'
}
export const textIndexProperties: Array<FormElementType> =[
  FormElementType.textField,
  FormElementType.textArea,
  FormElementType.dropdown,
  FormElementType.lookupField,
  FormElementType.checkboxGroup,
  FormElementType.radioButtonGroup
];

export const dateIndexProperties: Array<FormElementType> =[
  FormElementType.dateTimePicker,
]

export const numericIndexProperties: Array<FormElementType> =[
  FormElementType.textField,
]

export const IndexTypeName = {
  [IndexType.Keyword]: "Text",
  [IndexType.Double]: "Numeric",
  [IndexType.Date]: "Date",
}